import _ from 'underscore';

export const FeedParameters = {
  StoreId: 'StoreId',
  FeedId: 'FeedId',
};

export function getFeedInfo(campaignSetting) {
  const rawStoreId = _.get(campaignSetting, 'ProviderId');
  const rawFeedId = _.get(campaignSetting, 'FeedId');
  const feedInfo = {};
  if (rawStoreId) {
    feedInfo[FeedParameters.StoreId] = parseInt(rawStoreId, 10);
  }
  if (rawFeedId) {
    feedInfo[FeedParameters.FeedId] = parseInt(rawFeedId, 10);
  }
  return feedInfo;
}
